import { Directive, ElementRef } from '@angular/core';

@Directive({ selector: '[appOffsetTop]', standalone: false})
export class OffsetTopDirective {
	constructor (private _el: ElementRef) { }
	get offsetTop (): number { return this._el.nativeElement.offsetTop; }
	get text (): number { return this._el.nativeElement.getElementsByClassName('text-en')[0]?.textContent; }
}
